module.exports = __webpack_public_path__ + "img/about-b-slide4.5674eff2.jpg";